<template>
  <component :is="currentLayout">
    <slot />
  </component>
</template>

<script>
import store from '@/services/store';

import LayoutBase from '@/layouts/base/LayoutBase.vue';
import LayoutEmpty from '@/layouts/LayoutEmpty.vue';
import LayoutLogin from '@/layouts/LayoutLogin.vue';

export default {
  name: 'LayoutProvider',

  components: {
    LayoutBase,
    LayoutEmpty,
    LayoutLogin,
  },

  computed: {
    currentLayout: () => store.state.layout.currentLayout,
  },
};
</script>
